export const initialState = {
  currentUrlPath: '',
  location: '',
  isMobile: false,
  isHeaderMenuActive: false,
  activeLargeCategory: 'all',
  activeSmallCategory: 'all',
  isSearching: false,
  searchKeyword: '',
  searchInputRef: '',
}

export const reducer = (state, action) => {
  const { type, payload } = action
  switch(type) {
    case 'SetGlobalLocation':
      return {
        ...state, 
        location: payload, 
        activeLargeCategory: payload?.state?.large ? payload.state.large : 'all', 
        activeSmallCategory: payload?.state?.small ? payload.state.small : 'all', 
      }
    case 'SetCurrentUrlPath':
      return {...state, currentUrlPath: payload}
    case 'HeaderMenuActive':
      return {...state, isHeaderMenuActive: payload }
    case 'ResizeWindow':
      return {...state, isMobile: payload <= 900 ? true : false}
    case 'SelectLargeCategory':
      return {...state, activeLargeCategory: payload.large, activeSmallCategory: payload.small}
    case 'SelectSmallCategory':
      return {...state, activeSmallCategory: payload.small}
    case 'SearchToggle':
      return {...state, isSearching: payload}
    case 'SetSearchKeyword':
      return {...state, searchKeyword: payload}
    case 'SetSearchInputRef':
      return {...state, searchInputRef: payload}
    default:
      return state
  }
}